import './App.css';
import './App.scss';
import PageContainer from "./components/PageContainer";

function App() {
  return (
    <div className="App">
      {/* <Nav />
      <div style={{backgroundImage: `url(/images/brick.jpg)`}}>
      <div className="container" >
          <PorfolioContent />
        </div>
      </div>
        
      
      <Footer /> */}
      <PageContainer />
    </div>
  );
}

export default App;
